import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { filterNotNull } from "@epdk/util/rxjs";
import { distinctUntilChanged, Observable, shareReplay } from "rxjs";
import { ContentHubLink } from "../../../shared/data/content-hub-link";
import { CmsContentService } from "../../../shared/services/cms-content.service";
import { cityOnMarsSwiperData, cityOnMarsTileData, firstHumansSwiperData, landingOnMarsTileData, mars2026TileData, marsMissionsData, marsPageFooterData, marsStats, marsTitleTileData, starshipTile, whyMarsData } from "./mars-and-beyond.page.data";
@Component({
  selector: "mars-and-beyond-page",
  templateUrl: "./mars-and-beyond.page.html",
  styleUrls: ["./mars-and-beyond.page.scss", "./mars-and-beyond.mobile.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarsAndBeyondPage {
  readonly marsTitleTileData = marsTitleTileData;
  readonly cityOnMarsTileData = cityOnMarsTileData;
  readonly whyMarsData = whyMarsData;
  readonly starshipTile = starshipTile;
  readonly marsStats = marsStats;
  readonly firstHumansSwiperData = firstHumansSwiperData;
  readonly cityOnMarsSwiperData = cityOnMarsSwiperData;
  readonly marsMissionsData = marsMissionsData;
  readonly landingOnMarsTileData = landingOnMarsTileData;
  readonly mars2026TileData = mars2026TileData;
  readonly marsPageFooterData = marsPageFooterData;

  readonly contentHubLink$: Observable<ContentHubLink>;

  constructor(private _cmsContentService: CmsContentService, private _titleService: Title, @Inject('contentHubEnabled') public contentHubEnabledToken: string | boolean) {
    this.contentHubLink$ = this._cmsContentService.getContentHubLinkByPage("mars").pipe(
      filterNotNull(),
      distinctUntilChanged(),
      shareReplay(1)
    );

    this._titleService.setTitle('SpaceX - Mission: Mars');
  }

  get contentHubEnabled(): boolean {
    return this.contentHubEnabledToken === "true" || this.contentHubEnabledToken === true;
  }
}
